import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PriceRow } from "./PriceRow";
import { Divider } from "@bookips/sds";
export const AdditionalPayment = (param)=>{
    let { paymentMethod  } = param;
    const { usedCashAmount , usedPointAmount  } = paymentMethod;
    const hasPaymentMethod = usedCashAmount && usedCashAmount > 0 || usedPointAmount && usedPointAmount > 0;
    if (!hasPaymentMethod) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2",
        children: [
            usedCashAmount > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Divider, {
                        className: "bg-gray-900/10"
                    }),
                    /*#__PURE__*/ _jsx(PriceRow, {
                        label: "캐시",
                        amount: usedCashAmount,
                        variant: "body1",
                        isNegative: true
                    })
                ]
            }),
            usedPointAmount > 0 && /*#__PURE__*/ _jsx(PriceRow, {
                label: "포인트",
                amount: usedPointAmount,
                variant: "body1",
                isNegative: true
            })
        ]
    });
};
